 document.addEventListener('DOMContentLoaded', () => {
      const haloQty = document.querySelector('.halo-qty');
      const inventory = parseInt(haloQty.getAttribute('data-inventory'), 10);
      const haloProduct = document.querySelector('.template-product-smart-helmet');
   console.log("INV",inventory);
  
      if (inventory <= 0) {
       //haloProduct.classList.add('stock-out')
      }
  });


document.addEventListener("DOMContentLoaded", () => {
  appendsizeChart(
    ".product-block.product-block--size_guide",
    ".template-product .product .product__grid .product-block--variant_picker .options-selector .option-selectable-boxes :nth-child(2)"
  );
  appendsizeChart(
    ".product-block.product-block--size_guide",
    ".template-product-smart-helmet .product .product__grid .product-block--variant_picker .options-selector .option-selectable-boxes :nth-child(2)"
  );
});

function appendsizeChart(container, appendTo) {
  // To Append Size Chart Below Size Variant Options (Product Page)
  let sizeChartContainer = document.querySelector(container);
  let sizeChartDiv = document.querySelector(appendTo);
  if (sizeChartDiv != null || sizeChartDiv != undefined) {
    sizeChartDiv.parentNode.insertBefore(
      sizeChartContainer,
      sizeChartDiv.nextSibling
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let shopTheLookDiv = document.querySelector(
    ".shop-the-look-slider.splide .splide__track .splide__list.splide-list-parent-container"
  );
  let shopTheLookContainer1 = document.getElementById(
    "shopify-section-template--22238145315109__cc64745e-0881-4efb-9caf-5ccc27a8504a"
  );
  let shopTheLookContainer2 = document.getElementById(
    "shopify-section-template--22238145315109__eb735814-2d7c-4f6e-83f2-472912277be1"
  );
  let shopTheLookContainer3 = document.getElementById(
    "shopify-section-template--22238145315109__26eab333-3399-477a-a583-f22d6a7e9f4a"
  );

  if (shopTheLookDiv != null || shopTheLookDiv != undefined) {
    shopTheLookDiv.appendChild(shopTheLookContainer1);
    shopTheLookDiv.appendChild(shopTheLookContainer2);
    shopTheLookDiv.appendChild(shopTheLookContainer3);
  }

  var shopTheLookSlider = document.querySelector("#shopTheLookSlider");
  if (shopTheLookSlider) {
    new Splide("#shopTheLookSlider", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      arrows: false,
      passive: true,
    }).mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Get the current URL
  var currentUrl = window.location.href;

  // Check if the URL contains "collections/ather-accessories"
  //if (currentUrl.includes("collections/ather-smart-helmets")) {
  if (currentUrl.includes("collections/smart-helmets")) {
    // Get the first child of the li element
    var firstChild = document.querySelector(
      ".nav-desktop__tier-1-item:nth-child(2)"
    );

    // Add text decoration underline
    if (firstChild) {
      firstChild.style.textDecoration = "underline";
    }
  }

  // Check if the URL contains "collections/ather-merchandise"
  if (currentUrl.includes("collections/ather-accessories")) {
    // Get the first child of the li element
    var firstChild = document.querySelector(
      ".nav-desktop__tier-1-item:first-child"
    );

    // Add text decoration underline
    if (firstChild) {
      firstChild.style.textDecoration = "underline";
    }
  }

  // Check if the URL contains "collections/ather-merchandise"
  if (currentUrl.includes("collections/ather-merch")) {
    // Get the first child of the li element
    var firstChild = document.querySelector(
      ".nav-desktop__tier-1-item:nth-child(3)"
    );

    // Add text decoration underline
    if (firstChild) {
      firstChild.style.textDecoration = "underline";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  var modalPopup = document.getElementById("modalPopup");
  var modalPopupBtn = document.getElementsByClassName("modalPopupBtn");
  var modalPopupClose = document.getElementsByClassName(
    "modal-popup-content-close"
  )[0];

  if (modalPopup) {
    for (var i = 0; i < modalPopupBtn.length; i++) {
      modalPopupBtn[i].addEventListener(
        "click",
        function () {
          modalPopup.style.display = "flex";
          document.querySelector("body").style.overflow = "hidden";
        },
        { passive: true }
      );
    }

    modalPopupClose.onclick = function () {
      modalPopup.style.display = "none";
      document.querySelector("body").style.overflow = "unset";
    };

    window.onclick = function (event) {
      if (event.target == modalPopup) {
        modalPopup.style.display = "none";
        document.querySelector("body").style.overflow = "unset";
      }
    };

    // Add the keydown event listener to the document
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 27) {
        modalPopup.style.display = "none";
        document.querySelector("body").style.overflow = "unset";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // var notifyModalPopup = document.getElementById("notifyModalPopup");
  var notifymodalPopup = document.querySelectorAll(".product-block");
  var notifymodalPopupBtn = document.getElementsByClassName(
    "notifyModalPopupBtn"
  );
  var testId = document.getElementById("form-container-ref");
  notifymodalPopup.forEach((e) => {
    if (e.classList.contains("product-block--@app")) {
      var closeDiv = document.createElement("div");
      closeDiv.className = "closeNotifyButton";
      closeDiv.innerHTML =
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 1L13 13M1 13L13 1" stroke="#9A9C9D" stroke-width="1.33333" stroke-linecap="round"/> </svg>';
      closeDiv.onclick = () => {
        e.classList.remove("showPopupForm");
        document
          .querySelectorAll(".closeNotifyoverlay")
          .forEach((e) => (e.style.display = "none"));
      };
      var closeOverlayDiv = document.createElement("div");
      closeOverlayDiv.className = "closeNotifyoverlay";
      closeOverlayDiv.onclick = () => {
        e.classList.remove("showPopupForm");
        document.querySelectorAll(".closeNotifyoverlay").forEach((e) => {
          e.style.display = "none";
        });
      };
      e.appendChild(closeDiv);
      e.appendChild(closeOverlayDiv);
    }
  });

  for (var i = 0; i < notifymodalPopupBtn.length; i++) {
    notifymodalPopupBtn[i].addEventListener("click", function () {
      var myFormList = [];
      notifymodalPopup.forEach((e) => {
        if (e.classList.contains("product-block--@app")) {
          myFormList.push(e);
        }
      });

      myFormList.forEach((e, index) => {
        let checkTitle = document.querySelector(
          ".product-block.product-block--title h1"
        );
        console.log(
          checkTitle.innerHTML.toLowerCase() === "halo bit",
          "checkTitle1"
        );
        if (checkTitle.innerHTML.toLowerCase() === "halo bit") {
          myFormList[0].classList.add("Hideform");
        } else {
          myFormList[1].classList.add("Hideform");
        }
        console.log(
          e.classList.contains("Hideform"),
          'e.classList.contains("Hideform")'
        );
        if (e.classList.contains("Hideform")) {
          e.classList.add("showPopupForm");
          document
            .querySelectorAll(".closeNotifyoverlay")
            .forEach((e) => (e.style.display = "block"));
        }
      });
      // notifymodalPopup.style.display = "flex !important";
    });
  }

  // var notifymodalPopupClose = document.getElementsByClassName("notify-modal-popup-content-close")[0];

  // if(modalPopup) {
  //   for (var i = 0; i < notifymodalPopupBtn.length; i++) {
  //       notifymodalPopupBtn[i].addEventListener('click', function () {
  //           notifyModalPopup.style.display = "flex";
  //           document.querySelector('body').style.overflow = "hidden";
  //       }, { passive: true });
  //   }

  //   notifymodalPopupClose.onclick = function () {
  //       notifyModalPopup.style.display = "none";
  //       document.querySelector('body').style.overflow = "unset";
  //   }

  //   window.onclick = function (event) {
  //       if (event.target == notifyModalPopup) {
  //           notifyModalPopup.style.display = "none";
  //           document.querySelector('body').style.overflow = "unset";
  //       }
  //   }

  //   // Add the keydown event listener to the document
  //   document.addEventListener('keydown', function(event) {
  //       if (event.keyCode === 27) {
  //           notifyModalPopup.style.display = "none";
  //           document.querySelector('body').style.overflow = "unset";
  //       }
  //   });
  // }
});

//
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    // Select all video containers
    let videoContainers = document.querySelectorAll(
      ".hero-section-video-container"
    );
    const videoContainers1 = document.querySelectorAll(".container-sticky");
    videoContainers = [...videoContainers, ...videoContainers1];
    // Loop through each video container
    videoContainers.forEach((videoContainer) => {
      let video = videoContainer.querySelector("video");
      if (videoContainer.classList.contains("container-sticky")) {
        video =
          window.innerWidth < 768
            ? videoContainer
                .querySelector(".sticky-video-overlay-parallax")
                .querySelectorAll("video")[1]
            : videoContainer.querySelectorAll("video")[2];
        console.log(
          videoContainer.querySelector(".sticky-video-overlay-parallax"),
          "video-"
        );
      }
      const mutedButton = videoContainer.querySelector(".muted");
      const notMutedButton = videoContainer.querySelector(".not-muted");

      // Attach click event listener to the muted button
      if (mutedButton != null && mutedButton != "undefined") {
        mutedButton.addEventListener("click", () => {
          toggleMute(video);
          mutedButton.classList.add("active");
          notMutedButton.classList.add("active");
        });

        // Attach click event listener to the not-muted button
        notMutedButton.addEventListener("click", () => {
          toggleMute(video);
          mutedButton.classList.remove("active");
          notMutedButton.classList.remove("active");
        });
      }
    });
  }, 2000);
});

function toggleMute(video) {
  // Toggle the muted attribute of the video element
  video.muted = !video.muted;
}

//
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(
    ".smart-helmets-interactions-section_video-content-twin video, .smart-helmets-interactions-section_video-slider video"
  );
  videos.forEach((video) => {
    // Mute the video
    // video.muted = true;

    video.play();

    // Set a timeout to stop the video after 1 second
    setTimeout(function () {
      video.pause();
    }, 1000); // 1000 milliseconds = 1 second

    // Play video on mouse enter
    video.addEventListener("mouseenter", () => {
      videos.forEach((otherVideo) => {
        if (otherVideo !== video) {
          otherVideo.pause(); // Pause all other videos
        }
      });
      video.play(); // Play the hovered video
    });

    // Pause video on mouse leave, unless hovering over controls
    video.addEventListener("mouseleave", (event) => {
      const e = event.relatedTarget;
      if (
        e &&
        (e.parentNode === video ||
          e === video ||
          e.closest(".hero-section-video-container"))
      ) {
        return; // Do nothing if hovering over the video or its controls
      }
      video.pause();
    });
  });
});

// Smart Helmet Update Starts //

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
  var halo_page = document.getElementById("portSecVideo");
  if (halo_page !== null && halo_page !== undefined) {
    // const lenis = new Lenis({
    //   duration: 3.5,
    //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -8 * t)),
    //   orientation: "vertical",
    //   gestureOrientation: "vertical",
    //   smoothWheel: true,
    //   wheelMultiplier: 1,
    //   smoothTouch: false,
    //   touchMultiplier: 2,
    //   infinite: false,
    // });

    function raf(time) {
      // lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // lenis.on("scroll", ScrollTrigger.update);

    gsap.registerPlugin(ScrollTrigger);

    const videoElement = document.querySelector("#portSecVideo video");
    const halointrovideo = document.querySelector("#halo-intro-video-1 video");
    const captionElement = document.querySelector(
      ".smart-helmets-interactions-section_content-top"
    );

    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (videoElement.paused) {
              videoElement.play();
            }
          } else {
            if (!videoElement.paused) {
              videoElement.pause();
            }
          }
        });
      },
      { threshold: 0.5 }
    ); // Adjust threshold as needed

    if (videoElement) {
      videoObserver.observe(videoElement);
    }
    if (halointrovideo) {
      videoObserver.observe(halointrovideo);
    }

    // Product Page Animation
    //(1) Desktop Version

    const tlHpVideoReveal = gsap.timeline();
    const heroVideoElements = document.querySelectorAll(".main_videos video");

    tlHpVideoReveal.to(captionElement, {
      // yPercent: 450,
      ease: "none",
      scrollTrigger: {
        trigger: ".smart-helmets-interactions-section",
        start: "top top", // the default values
        end: "bottom top",
        scrub: true,
      },
    });

    heroVideoElements.forEach((heroVideoElement) => {
      // IntersectionObserver for the hero video
      const heroVideoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (heroVideoElement.paused) {
                heroVideoElement.play();
              }
            } else {
              if (!heroVideoElement.paused) {
                heroVideoElement.pause();
              }
            }
          });
        },
        { threshold: 0.5 }
      ); // Adjust threshold as needed

      if (heroVideoElement) {
        heroVideoObserver.observe(heroVideoElement);
      }
      tlHpVideoReveal.to(heroVideoElement, {
        scrollTrigger: {
          trigger: heroVideoElement,
          markers: false,
          start: "30% bottom",
          end: "80% center",
          scrub: true,
        },
        scale: 1,
        duration: 10, // Adjust the duration to slow down the animation (in seconds)
        ease: "power2.inOut", // Add easing to the animation
      });
    });
    ScrollTrigger.refresh();

    //(3) Selecting the first child of .smart-helmets-interactions-section_videos-half
    const firstVideoElement = document.querySelector(
      ".smart-helmets-interactions-section_videos-half:first-child video"
    );

    // IntersectionObserver for the first video element
    const videoObserver3 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (firstVideoElement.paused) {
              firstVideoElement.play();
            }
          } else {
            if (!firstVideoElement.paused) {
              firstVideoElement.pause();
            }
          }
        });
      },
      { threshold: 1 }
    ); // Adjust threshold as needed

    // Observing the first video element
    if (firstVideoElement) {
      videoObserver3.observe(firstVideoElement);
    }

    const lastVideoElement = document.querySelector(
      ".smart-helmets-interactions-section_videos-half:last-child video"
    );

    // IntersectionObserver for the last video element
    const videoObserver4 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (lastVideoElement.paused) {
              lastVideoElement.play();
            }
          } else {
            if (!lastVideoElement.paused) {
              lastVideoElement.pause();
            }
          }
        });
      },
      { threshold: 1 }
    ); // Adjust threshold as needed

    // Observing the last video element
    if (lastVideoElement && window.innerWidth <= 768) {
      videoObserver4.observe(lastVideoElement);
    }
    //
    // Function to add the active class
    // function addActiveClass() {
    //   const stickyAddToCart = document.querySelector(".sticky-add-to-cart");
    //   stickyAddToCart.classList.add("active");
    // }

    // Function to remove the active class
    // function removeActiveClass() {
    //   const stickyAddToCart = document.querySelector(".sticky-add-to-cart");
    //   stickyAddToCart.classList.remove("active");
    // }

    // Define ScrollTrigger to add active class when element enters viewport
    // gsap.registerPlugin(ScrollTrigger);

    // ScrollTrigger.create({
    //   trigger: ".smart-helmets-interactions-section_content",
    //   start: "top top=-200", // Trigger when the top of the element hits the bottom of the viewport
    //   onEnter: addActiveClass,
    //   onLeaveBack: removeActiveClass, // Remove the active class when the element leaves the viewport
    // });

    //
    // Product Page Animation
  }
});
// Smart Helmet Update Ends //

// Smart helmet prebook
function addToCart(productId, quantity = 1) {
  console.log(productId, "productId");
  var items = [
    {
      id: productId,
      quantity: quantity,
    },
  ];

  fetch("/cart/add/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: items, // Pass the items array as the value of the "items" parameter
    }),
  })
    .then((response) => {
      if (response.ok) {
        // Product added successfully

        var spanElement = document.querySelector(".notifyModalPopupBtn span");
        if (spanElement) {
          spanElement.textContent = "Redirecting...";
        }
        window.location.href = "/checkout";
        setTimeout(() => {
          // spanElement.textContent = "Pre-book for ₹ 499 ";
          // spanElement.textContent = "Pre Book";
          spanElement.textContent = "Add to cart";
          const disabledButton = document.querySelector(
            ".template-product-smart-helmet .satc-notify-btn:disabled"
          );
          disabledButton.disabled = false;
        }, 500);
        // Optionally, update the cart display
        // You may reload the page or update the cart icon/count
      } else {
        // Product could not be added
        alert("Failed to add product to cart.");
        console.log(response);
      }
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
}

// Example usage:
// document.addEventListener("DOMContentLoaded", function () {
//   var addToCartButtons = document.querySelectorAll(
//     ".template-product-smart-helmet .satc-notify-btn"
//   );
//   var spanElement = document.querySelector(".notifyModalPopupBtn span");

//   addToCartButtons.forEach(function (button) {
//     button.addEventListener("click", function (event) {
//       button.disabled = true;
//       var productId = "48435324748069";
//       var quantity = 1;
//       addToCartProduct(productId, quantity,e);
//       if (spanElement) {
//         spanElement.textContent = "Adding to Cart...";
//       }
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   let stickyCart = document.querySelector(".sticky-add-to-cart");
//   let visited;
//   const stickyObserver = new IntersectionObserver(
//     (entries) => {
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           visited = true;
//         }
//       });
//     },
//     { threshold: 0.5 }
//   ); // Adjust threshold as needed

//   if (stickyCart) {
//     stickyObserver.observe(stickyCart);
//     document.addEventListener("scroll", () => {
//       if (visited) {
//         if (window.scrollY > 3000) {
//           stickyCart.style.position = "sticky";
//         } else {
//           stickyCart.style.position = "fixed";
//           stickyCart.style.bottom = "0px";
//           stickyCart.style.bottom = "0px";
//           stickyCart.style.opacity = "1";
//           stickyCart.style.transform = "translateY(0)";
//         }
//       }
//     });
//   }
// });

// FAQ
document.addEventListener("DOMContentLoaded", function () {
  let faqPopupContainerDiv = document.querySelector(".faqPopupContainerDiv");
  if (faqPopupOverlayDiv) {
    let { height: containerHeight } =
      faqPopupContainerDiv.getBoundingClientRect();
    var faqPopupOverlayDiv = document.querySelector(".faqPopupOverlayDiv");
    faqPopupOverlayDiv.style.height = containerHeight + "px";
  }
  FAQAccordion();
});

function FAQAccordion() {
  var questions = document.querySelectorAll(".at-qt");
  var prevactive, prevmainActive;
  if (questions != null) {
    questions.forEach(function (question) {
      question.addEventListener("click", function () {
        if (prevmainActive) {
          if (prevmainActive == this) {
            let activeP = document.querySelector(".at-qt.active ~ .at-ans");
            if (activeP) {
              activeP.style.height = "0px";
              prevmainActive.classList.remove("active");
              return;
            } else {
              prevmainActive.classList.remove("active");
            }
          } else {
            prevmainActive.classList.remove("active");
          }
        }
        this.classList.toggle("active");
        prevmainActive = this;
        if (prevactive) {
          prevactive.style.height = "0px";
        }
        let activeP = document.querySelector(".at-qt.active ~ .at-ans");
        if (activeP) {
          if (activeP.scrollHeight > 0) {
            activeP.style.height = activeP.scrollHeight + "px";
            prevactive = activeP;
          } else {
            activeP.style.height = "0px";
          }
        } else {
          prevactive.style.height = "0px";
        }
      });
    });
    if (questions[0]) questions[0].click();
  }
}

//FAQ popup
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("scroll", () => {
    var myFawSection = document.getElementById("faqPopupSection");
    if (myFawSection) {
      if (window.scrollY < 600) {
        myFawSection.style.position = "absolute";
      } else {
        myFawSection.style.position = "fixed";
      }
    }
  });
  const popupDiv = document.getElementById("faqPopup");
  const PopupSection = document.getElementById("faqPopupSection");
  const faqPopupOverlayDiv = document.querySelector(".faqPopupOverlayDiv");
  if (faqPopupOverlayDiv) {
    faqPopupOverlayDiv.addEventListener("click", () =>
      closeFaqPopupSection(PopupSection)
    );
  }
  if (document.querySelector(".faqcloseDiv")) {
    document
      .querySelector(".faqcloseDiv")
      .addEventListener("click", () => closeFaqPopupSection(PopupSection));
  }
  if (popupDiv) {
    popupDiv.addEventListener("click", function () {
      const PopupContainer = document.getElementById("faqPopupContainer");
      PopupSection.classList.toggle("faqOpen");
      document.querySelector("body").style.overflowY = "hidden";
    });
  }
});

function closeFaqPopupSection(PopupSection) {
  if (PopupSection.classList.contains("faqOpen")) {
    let questions = document.querySelectorAll(".at-qt");
    if (!questions[0].classList.contains("active")) questions[0].click();
  }
  document.querySelector("body").style.overflowY = "auto";

  var div = document.getElementById("faqPopupSection");
  div.scrollTo({ behaviour: "smooth", top: 0 });
  PopupSection.classList.toggle("faqOpen");
}

//animation of Helmet page noise cancellation module animation
document.addEventListener("DOMContentLoaded", function () {
  if (typeof gsap !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);

    const createScrollTimeline = (
      triggerElement,
      start,
      end,
      scrub,
      options = {}
    ) => {
      return gsap.timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: start,
          end: end,
          scrub: scrub || true,
          ...options, // Additional ScrollTrigger options can be passed in
        },
      });
    };

    // Use ScrollTrigger.matchMedia instead of gsap.matchMedia
    ScrollTrigger.matchMedia({
      // For screens below 768px
      "(max-width: 767px)": function () {
        gsap.set(".container-sticky", { marging: "0" });
        var mytimeLine = gsap.timeline({
          scrollTrigger: {
            trigger: ".container-sticky",
            start: "center center", // Start the animation when the top of the trigger hits the center of the viewport
            end: "+=180%", // Adjust this as per the amount of scroll needed
            pin: true,
            scrub: true,
          },
        });

        // Set the initial position of .sticky-video-overlay-parallax to top: 100%
        gsap.set(".sticky-video-overlay-parallax", { top: "100%" });
        gsap.set(".overlay-text", { bottom: "-35%" });

        let letters = document.querySelector(".overlay-text");
        if (letters) letters = letters.children; // Get all individual letter elements

        // Set initial opacity of all letters to 0
        gsap.set(letters, { opacity: 0.5 });

        // Animation timeline
        mytimeLine
          .to(
            ".sticky-video-overlay-parallax",
            {
              top: "0%",
              duration: 3,
            },
            0
          )
          .to(
            ".overlay-text",
            {
              bottom: "90%",
              duration: 3,
            },
            2
          )
          .to(
            letters,
            {
              opacity: 1,
              duration: 0.03, // Shorten duration for each letter's fade-in
              stagger: 0.01, // Delay between each letter
            },
            2
          );
      },

      // For screens 768px and above
      "(min-width: 768px)": function () {
        gsap.set(".container-sticky", { marging: "0" });
        gsap.to(".container-sticky", {
          scrollTrigger: {
            trigger: ".container-sticky",
            start: "center center-=5%",
            end: "+=350%",
            pin: true,
            scrub: true,
          },
        });

        var masterTimeline = createScrollTimeline(
          ".container-sticky",
          "center center-=5%",
          "+=350%"
        );

        gsap.set(".overlay-text span", {
          opacity: 0.5,
        });
        gsap.set(".sticky-video-audio", {
          opacity: 0,
        });
        gsap.set(".overlay-text", {
          bottom: "-90%",
        });

        let letters = document.querySelector(".overlay-text");
        if (letters) letters = letters.children;

        var textTimeline = createScrollTimeline(
          ".sticky-video-overlay-parallax",
          "top top-=50%",
          "+=350%"
        );

        textTimeline.to(
          ".overlay-text",
          {
            bottom: "85%",
            stagger: { amount: -1 },
            duration: 20, // Animation duration for desktop
          },
          0
        );

        var textstaggerTimeline = createScrollTimeline(
          ".sticky-video-overlay-parallax",
          "top top-=90%",
          "+=80%"
        );

        textstaggerTimeline.to(letters, {
          opacity: 1,
          duration: 0.01, // Animation duration for desktop
          stagger: 2,
        });

        masterTimeline
          .to(
            ".sticky-video-audio",
            {
              opacity: 1,
              duration: 0,
            },
            0.2
          )
          .to(
            ".sticky-video-overlay-parallax",
            {
              y: "-100%",
              scrub: 0.05,
              duration: 3,
            },
            0
          );
      },
    });

    // let resizeTimeout;
    // window.addEventListener("scroll", () => {
    //   clearTimeout(resizeTimeout);
    //   resizeTimeout = setTimeout(() => {
    //     ScrollTrigger.refresh();
    //   }, 250); // Adjust the debounce delay as needed
    // });
  }
});

window.addEventListener("DOMContentLoaded", (event) => {
  let prevscroll = 0,
    setTimeoutId;
  let header = document.querySelector(".shopify-section.section-header");
  window.addEventListener("scroll", (e) => {
    const isbanner = window.location.pathname == "/";
    const isBannerVisible = window.scrollY > 70;
    if (prevscroll > window.scrollY) {
      header.style.top = "0px";
    } else if (prevscroll < window.scrollY && window.scrollY > 100) {
      header.style.top = isBannerVisible ? "-90px" : "0px";
    }
    setTimeoutId = setTimeout(() => {
      prevscroll = window.scrollY;
    }, 100);
  });
});
window.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener("click", (e) => {
    if (document.querySelectorAll(".coupan-apply").length > 0) {
      document.querySelectorAll(".coupan-apply").forEach((e) => {
        console.log(e, "e");
        e.addEventListener("click", (e) => {
          let coupan = e.getAttribute("data");
          console.log(coupan, "coupan");
          e.setAttribute("data-isin", coupan);
        });
      });
      document
        .getElementById("checkoutButton")
        .addEventListener("click", (e) => {
          document.querySelectorAll(".coupan-apply").forEach((e, i) => {
            let coupan = e.getAttribute("data-isin");
            window.location.href = `https://shop-stage.ather.io/discount/${coupan}`;
          });
          window.location.href = `https://shop-stage.ather.io/checkout/`;
        });
    }
  });
});

//removing gap from header

// window.addEventListener("DOMContentLoaded", (event) => {
//   const nav = document.querySelector("nav.breadcrumbs");
//   const siteMap = document.getElementById("site-main");

//   if (nav) {
//     const computedStyle = window.getComputedStyle(nav);
//     console.log(computedStyle.display, "computedStyle.display");
//     if (computedStyle.display == "block") {
//       siteMap.style.marginTop = "0px";
//     } else {
//       siteMap.style.marginTop = "100px";
//     }
//   }
// });

window.addEventListener("DOMContentLoaded", (event) => {
  const containers = document.querySelectorAll(".offer-container");
  let flip = true;
  if (containers?.length > 0) {
    setInterval(() => {
      if (flip) {
        if (containers[0])
          containers[0].style.transform = "perspective(1000px) rotateX(180deg)";
        if (containers[1])
          containers[1].style.transform = "perspective(1000px) rotateX(0deg)";
      } else {
        if (containers[0])
          containers[0].style.transform = "perspective(1000px) rotateX(0deg)";
        if (containers[1])
          containers[1].style.transform = "perspective(1000px) rotateX(180deg)";
      }
      flip = !flip;
    }, 3000);
  }
});

//hide sizes based on category select on merch page
window.addEventListener("DOMContentLoaded", (event) => {
  let facetedFiltersForm = document.querySelectorAll(
    ".main-collection-grid__content--top-divider"
  );
  let facetedFiltersActive = document.querySelectorAll(
    ".faceted-filters__active"
  );
  let facetedFiltersActiveMobile = document.querySelectorAll(
    ".filters-active-mobile"
  );
  let facetedFilterListDiv = document.querySelectorAll(".faceted-filter");

  let mobileFilterDiv = document.querySelector(
    ".drawer-filter[data-key='filter.v.option.size']"
  );
  if (mobileFilterDiv) {
    //mobile
    mobileFilterDiv.addEventListener("click", (e) => {
      let isHelmet = [];
      facetedFiltersActiveMobile.forEach((e2) => {
        let Atags = e2.querySelectorAll("a");
        Atags.forEach((e3) => {
          if (!e3.classList.contains("filters-active-mobile__clear-all")) {
            isHelmet.push(e3.textContent.trim().toLowerCase());
          }
        });
      });
      console.log(isHelmet, "isHelmet");
      if (isHelmet.length > 0 && isHelmet.every((e) => e == "helmets")) {
        let listDiv = mobileFilterDiv.querySelectorAll(
          ".drawer-filter__list-item"
        );
        listDiv.forEach((e4) => {
          let input = e4.querySelector("input");
          let value = input.value.toUpperCase();
          if (value == "XS" || value == "S" || value == "XXL") {
            e4.style.display = "none";
          }
        });
      }
    });
  }
  //desktop
  facetedFiltersForm.forEach((e) => {
    e.addEventListener("click", (e1) => {
      let isHelmet = [];
      if (e1.target.textContent.trim().toLowerCase() == "size") {
        facetedFiltersActive.forEach((e2) => {
          let Atags = e2.querySelectorAll("a");
          Atags.forEach((e3) => {
            if (!e3.classList.contains("faceted-filters__clear-all")) {
              isHelmet.push(e3.textContent.trim().toLowerCase());
            }
          });
        });

        if (isHelmet.length > 0 && isHelmet.every((e) => e == "helmets")) {
          let facetedFilterListItem = [...facetedFilterListDiv].flatMap(
            (e5) => [...e5.querySelectorAll(".faceted-filter__list-item")]
          );
          facetedFilterListItem.forEach((e4) => {
            let input = e4.querySelector("input");
            let value = input.value.toUpperCase();
            if (value == "XS" || value == "S" || value == "XXL") {
              e4.style.display = "none";
            }
          });
        }
      }
    });
  });
});

async function addToCartProduct(productId, quantity = 1, Buttonevent) {
  if (Buttonevent) {
    Buttonevent.target.textContent = "Adding to cart...";
  }
  console.log("Attempting to add product to cart:", { productId, quantity });
  var items = [
    {
      id: productId,
      quantity: quantity,
    },
  ];

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      items: items, // Pass the items array as the value of the "items" parameter
    }),
  })
    .then((response) => {
      console.log(response, "response");
      if (response.ok) {
        if (Buttonevent) {
          Buttonevent.target.textContent = "Add to cart";
          // Before reloading the page, set a flag in sessionStorage
          sessionStorage.setItem("triggerCartClick", "true");
          // Reload the page
          window.location.reload();
        }
      } else {
        alert("Failed to add product to cart.");
      }
    })
    .catch((error) => {
      if (Buttonevent) {
        Buttonevent.target.textContent = "Add to cart";
      }
      console.error("Error adding product to cart:", error);
    });
}

//--start-- cart click event logic and appending pair of halobit logic --start--
window.addClicktoButtonCart = () => {
  let cartDiv = document.querySelector("#cart");
  console.log(cartDiv, "cartDiv");
  if (cartDiv) {
    document.querySelector("#cart").addEventListener("click", function (e) {
      if (e.target.classList.contains("product_upsell_Add-to-cart")) {
        let productId = e.target.getAttribute("data-product-id");
        let quantity = 1;
        addToCartProduct(productId, quantity, e);
      }
    });
  }
};
window.quickShopOpened = () => {
  appendsizeChart(
    ".product-quickshop-block--size_guide",
    ".product-quickshop-block--variant_picker .variant-picker .options-selector .option-selectable-boxes:nth-child(2)"
  );
  const sizeChartBtn = document.querySelector(
    ".product-quickshop-block.product-quickshop-block--size_guide"
  );
  if (sizeChartBtn) {
    // SVG for the ruler icon
    const RulerSvg = `
             <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 15 7" fill="none">
               <path d="M1.5 6.5C0.65625 6.5 0 5.84375 0 5V2C0 1.17969 0.65625 0.5 1.5 0.5H13.5C14.3203 0.5 15 1.17969 15 2V5C15 5.84375 14.3203 6.5 13.5 6.5H1.5ZM1.5 5.75H13.5C13.8984 5.75 14.25 5.42188 14.25 5V2C14.25 1.60156 13.8984 1.25 13.5 1.25H12.375V2.75C12.375 2.96094 12.1875 3.125 12 3.125C11.7891 3.125 11.625 2.96094 11.625 2.75V1.25H10.125V2.75C10.125 2.96094 9.9375 3.125 9.75 3.125C9.53906 3.125 9.375 2.96094 9.375 2.75V1.25H7.875V2.75C7.875 2.96094 7.6875 3.125 7.5 3.125C7.28906 3.125 7.125 2.96094 7.125 2.75V1.25H5.625V2.75C5.625 2.96094 5.4375 3.125 5.25 3.125C5.03906 3.125 4.875 2.96094 4.875 2.75V1.25H3.375V2.75C3.375 2.96094 3.1875 3.125 3 3.125C2.78906 3.125 2.625 2.96094 2.625 2.75V1.25H1.5C1.07812 1.25 0.75 1.60156 0.75 2V5C0.75 5.42188 1.07812 5.75 1.5 5.75Z" fill="#191919"/>
             </svg>`;

    //   // Update the SVG icon in the size guide button
    const sizeGuideButton = sizeChartBtn.querySelector(
      ".product-size-guide .product-size-guide__drawer-btn"
    );
    if (sizeGuideButton) {
      sizeGuideButton.querySelector("svg").outerHTML = RulerSvg;
    }
  }
  appendHtml(
    ".product-size-guide__drawer-btn", // clickeventclassName
    ".product-page-drawer__content", // containerClassName
    ".size-chart", // contentClassName
    ".product-details__title" // productName for conditional check
  );
};
window.addevent = (checkbtn) => {
  let setTimeoutId;
  clearTimeout(setTimeoutId);
  setTimeoutId = setTimeout(() => {
    addClicktoButtonCart();
  }, 2000);
};
window.addEventListener("DOMContentLoaded", (event) => {
  let headerCartButton = document.querySelector(".header__cart-button");
  let Mainaddtocartbutton = document.querySelector(
    ".template-product-product-halo-bit .button-action.button-action--primary"
  );
  console.log(Mainaddtocartbutton, "Mainaddtocartbutton");

  if (headerCartButton)
    headerCartButton.addEventListener("click", () => addevent());
  if (Mainaddtocartbutton)
    // console.log(Mainaddtocartbutton,"Mainaddtocartbutton");
    Mainaddtocartbutton.addEventListener("click", () => {
      console.log("clicked main action");
      addevent("main");
    });

  if (sessionStorage.getItem("triggerCartClick") === "true") {
    // Perform the click action
    document.querySelector(".header__cart-button").click();

    // Clear the flag so the action doesn't repeat on subsequent loads
    sessionStorage.removeItem("triggerCartClick");
  }
});
// window.callonAddToCart = () => {
//   console.log("adding..");
//   let setTimeoutId;
//   let Mainaddtocartbutton = document.querySelector(
//     ".template-product-product-halo-bit .button-action.button-action--primary"
//   );
//   const flyoutNotifications = document.querySelectorAll(
//     ".flyout__notification"
//   );
//   if (flyoutNotifications?.length > 0) {
//     flyoutNotifications.forEach((notification) => {
//       notification.style.display = "block";
//       notification.style.height = "fit-content";
//       addNotifcationDataOnQuantityInCart(
//         notification,
//         ".cart-drawer__notification-message"
//       );
//     });
//   }
//   clearTimeout(setTimeoutId);
//   setTimeoutId = setTimeout(() => {
//     RenderCartHalobit(Mainaddtocartbutton, true);
//   }, 500);
// };
window.RenderCartHalobit = function (button, istimeouted) {
  console.log("in render");
  let templetCartSection = document.querySelector(
    ".cart-drawer-form__table .templet-cart-section"
  );
  if (templetCartSection) {
    // console.log("in templetCartSection");

    return;
  }
  let pairID = button
    ? button.target
      ? button.target.getAttribute("data-product-id")
      : button.getAttribute("data-product-id")
    : localStorage.getItem("data-product-pair-id") || 0;
  let setTimeoutId;
  clearTimeout(setTimeoutId);
  setTimeoutId = setTimeout(
    () => {
      let isPariExist = document.querySelector(
        ".cart-data-product-checkExistid"
      );
      isPariExist = isPariExist
        ? isPariExist.getAttribute("data-product-id")
        : localStorage.getItem("data-product-pair-existid");
      let cartForm = document.querySelectorAll(".cart-drawer-form-item");
      for (let item of cartForm) {
        console.log("in loop");

        let cartFormid = item.getAttribute("data-cart-drawer-form-item");
        let cartformtrueid = cartFormid.split(":")[0];

        if (isPariExist == cartformtrueid) {
          console.log("in isPariExist == cartformtrueid");
          break;
        }

        if (cartformtrueid == pairID) {
          console.log("in cartformtrueid == pairID");
          let renderDiv = document.querySelector(".templet-cart-section");
          if (renderDiv) {
            console.log("in if renderDiv");
            localStorage.setItem("data-product-pair-div", renderDiv.outerHTML);
            renderDiv = renderDiv.cloneNode(true);
          } else {
            console.log("in else renderDiv");
            let savedDivHtml = localStorage.getItem("data-product-pair-div");
            if (savedDivHtml) {
              console.log("in savedDivHtml");

              let tempDiv = document.createElement("div");
              tempDiv.innerHTML = savedDivHtml;
              renderDiv = tempDiv.firstElementChild.cloneNode(true);
            }
          }
          console.log(renderDiv, "renderDiv");
          // Check if the renderDiv has already been inserted
          if (
            !item.nextElementSibling ||
            !item.nextElementSibling.classList.contains("templet-cart-section")
          ) {
            console.log(
              'in item.nextElementSibling || nextElementSibling.classList.contains("templet-cart-section")'
            );
            localStorage.setItem("data-product-pair-id", pairID);
            localStorage.setItem("data-product-pair-existid", isPariExist);
            console.log(item, "item");
            item.insertAdjacentElement("afterend", renderDiv);
          } else if (
            item.nextElementSibling.classList.contains("templet-cart-section")
          ) {
            item.nextElementSibling.remove();
            localStorage.setItem("data-product-pair-id", pairID);
            localStorage.setItem("data-product-pair-existid", isPariExist);
            console.log(item, "item");
            item.insertAdjacentElement("afterend", renderDiv);
          }
        }
      }
    },
    istimeouted ? 0 : 2000
  );
};

window.addEventListener("DOMContentLoaded", (event) => {
  let addtocartbutton = document.querySelectorAll(
    ".product_upsell_Add-to-cart"
  );
  let headerCartButton = document.querySelector(".header__cart-button ");
  let Mainaddtocartbutton = document.querySelector(
    ".template-product-product-halo-bit .button-action.button-action--primary"
  );

  if (headerCartButton) {
    headerCartButton.addEventListener("click", () => {
      RenderCartHalobit(Mainaddtocartbutton);
    });
  }
  if (Mainaddtocartbutton) {
    Mainaddtocartbutton.addEventListener("click", (e) => {
      RenderCartHalobit(e);
    });
  }

  if (addtocartbutton?.length > 0) {
    addtocartbutton.forEach((e) =>
      e.addEventListener("click", (e1) => {
        let productId = e1.target.getAttribute("data-product-id");
        let quantity = 1;
        addToCartProduct(productId, quantity, e1);
      })
    );
  }
});
//--end-- cart click event logic and appending pair of halobit logic --end--

// Removing add to cart message when removing product

window.getCartRefresh = (cnt, cnt1, res) => {
  let Mainaddtocartbutton = document.querySelector(
    ".template-product-product-halo-bit .button-action.button-action--primary"
  );
  if (Mainaddtocartbutton) {
    // console.log(Mainaddtocartbutton,"Mainaddtocartbutton");
    Mainaddtocartbutton.addEventListener("click", (e) =>
      window.RenderCartHalobit(e)
    );
  }
  console.log(cnt, cnt1, res);

  const flyoutNotifications = document.querySelectorAll(
    ".flyout__notification"
  );
  if (cnt1 > 0 && cnt < cnt1) {
    flyoutNotifications.forEach((notification) => {
      notification.style.display = "block";
      notification.style.height = "fit-content";
      addNotifcationDataOnQuantityInCart(
        notification,
        ".cart-drawer__notification-message"
      );
    });
  } else {
    flyoutNotifications.forEach((notification) => {
      notification.style.display = "none";
    });
  }
};

// Splide Functinality for halo page

document.addEventListener("DOMContentLoaded", function () {
  if (typeof Splide != "undefined") {
    const splide = new Splide(".halo-helmet-slider", {
      perPage: 2.5,
      gap: 24,
      start: 0,
      focus: 0,
      pagination: false,
      arrows: true,
      drag: "free",
      breakpoints: {
        1024: {
          perPage: 2,
          gap: 20,
        },
        768: {
          perPage: 1,
          gap: 15,
        },
        480: {
          perPage: 1,
          gap: 40,
        },
      },
    });

    splide.on("mounted move", function () {
      const prevButton = document.querySelector(".splide__arrow--prev");
      const nextButton = document.querySelector(".splide__arrow--next");

      if (splide.index === 0) {
        prevButton.style.opacity = "0.5";
        nextButton.style.opacity = "1";
      } else if (splide.index >= splide.length - splide.options.perPage) {
        nextButton.style.opacity = "0.5";
        prevButton.style.opacity = "1";
      } else {
        prevButton.style.opacity = "1";
        nextButton.style.opacity = "1";
      }
    });

    splide.mount();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const splideElements = document.querySelectorAll(
    ".splide, .splide__track, .splide__list, .splide__slide"
  );

  const mediaQueryList = window.matchMedia("(max-width: 768px)");

  function handleMediaQueryChange(event) {
    if (event.matches) {
      splideElements.forEach((element) => {
        element.classList.remove(
          "splide",
          "splide__track",
          "splide__list",
          "splide__slide"
        );
      });
    }
  }

  mediaQueryList.addEventListener("change", handleMediaQueryChange);
  handleMediaQueryChange(mediaQueryList);
});

// document.addEventListener("DOMContentLoaded", function () {

//   let helmetSizeChart = document.querySelector('.size-chart');
// if(helmetSizeChart){
//   helmetSizeChart.style.display ="none";
// }

//   });

function appendHtml(
  clickEventDivClass,
  containerClass,
  contentClass,
  productNameClass
) {
  var timeoutId;
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    let clickEventDiv = document.querySelector(clickEventDivClass);
    if (clickEventDiv) {
      clickEventDiv.addEventListener("click", function () {
        let productNameElement = document.querySelector(productNameClass);
        let productName = productNameElement
          ? productNameElement.textContent.trim()
          : null;

        console.log("Click event triggered."); // Check if the event listener is working
        console.log("Product Name:", productName); // Check if productName is captured

        // Check if productName contains both "Halo" and "Helmet"
        if (productName.includes("Halo") || productName.includes("Helmet")) {
          let container = document.querySelector(containerClass);
          let content = document.querySelector(contentClass);
          console.log("Container:", container); // Check if container is found
          console.log("Content:", content); // Check if content is found

          if (container && content) {
            container.innerHTML = content.innerHTML;
            console.log("HTML content added."); // Confirm HTML is added
          }
        } else {
          console.log(
            "Product name does not contain both 'Halo' and 'Helmet'."
          );
        }
      });
    }
  }, 500);
}

// Quick add button appending size chart guide
document.addEventListener("DOMContentLoaded", function () {
  const cartOpenButtons = document.querySelectorAll(
    ".product-card__quick-add-button"
  );

  cartOpenButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Call the appendHtml function (ensure this function is defined elsewhere)
      appendHtml(
        ".product-size-guide__drawer-btn", // clickeventclassName
        ".product-page-drawer__content", // containerClassName
        ".size-chart", // contentClassName
        ".product-details__title" // productName for conditional check
      );

      // // Select the size chart button and target containers
      // const sizeChartBtn = document.querySelector('.product-quickshop-block.product-quickshop-block--size_guide');

      // // Message to display if "Charger" is found
      // const inBootMsg = `
      //   <div class="product-block__text boot-charger">
      //     <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
      //       <path d="M5 0.25C7.75391 0.25 10 2.49609 10 5.25C10 8.02344 7.75391 10.25 5 10.25C2.22656 10.25 0 8.02344 0 5.25C0 2.49609 2.22656 0.25 5 0.25ZM5 9.625C7.40234 9.625 9.375 7.67188 9.375 5.25C9.375 2.84766 7.40234 0.875 5 0.875C2.57812 0.875 0.625 2.84766 0.625 5.25C0.625 7.67188 2.57812 9.625 5 9.625ZM5 3.84375C4.72656 3.84375 4.53125 3.64844 4.53125 3.375C4.53125 3.12109 4.72656 2.90625 5 2.90625C5.25391 2.90625 5.46875 3.12109 5.46875 3.375C5.46875 3.64844 5.25391 3.84375 5 3.84375ZM5.9375 7.125C6.09375 7.125 6.25 7.28125 6.25 7.4375C6.25 7.61328 6.09375 7.75 5.9375 7.75H4.0625C3.88672 7.75 3.75 7.61328 3.75 7.4375C3.75 7.28125 3.88672 7.125 4.0625 7.125H4.6875V5.25H4.375C4.19922 5.25 4.0625 5.11328 4.0625 4.9375C4.0625 4.78125 4.19922 4.625 4.375 4.625H5C5.15625 4.625 5.3125 4.78125 5.3125 4.9375V7.125H5.9375Z" fill="#5C6470"/>
      //     </svg>
      //     <span>In-boot charging is available only on Rizta</span>
      //   </div>`;
      // const sizeChartBtn = document.querySelector('.product-quickshop-block.product-quickshop-block--size_guide');
      //       if (sizeChartBtn) {

      //         // SVG for the ruler icon
      //         const RulerSvg = `
      //           <svg xmlns="http://www.w3.org/2000/svg" width="15" height="7" viewBox="0 0 15 7" fill="none">
      //             <path d="M1.5 6.5C0.65625 6.5 0 5.84375 0 5V2C0 1.17969 0.65625 0.5 1.5 0.5H13.5C14.3203 0.5 15 1.17969 15 2V5C15 5.84375 14.3203 6.5 13.5 6.5H1.5ZM1.5 5.75H13.5C13.8984 5.75 14.25 5.42188 14.25 5V2C14.25 1.60156 13.8984 1.25 13.5 1.25H12.375V2.75C12.375 2.96094 12.1875 3.125 12 3.125C11.7891 3.125 11.625 2.96094 11.625 2.75V1.25H10.125V2.75C10.125 2.96094 9.9375 3.125 9.75 3.125C9.53906 3.125 9.375 2.96094 9.375 2.75V1.25H7.875V2.75C7.875 2.96094 7.6875 3.125 7.5 3.125C7.28906 3.125 7.125 2.96094 7.125 2.75V1.25H5.625V2.75C5.625 2.96094 5.4375 3.125 5.25 3.125C5.03906 3.125 4.875 2.96094 4.875 2.75V1.25H3.375V2.75C3.375 2.96094 3.1875 3.125 3 3.125C2.78906 3.125 2.625 2.96094 2.625 2.75V1.25H1.5C1.07812 1.25 0.75 1.60156 0.75 2V5C0.75 5.42188 1.07812 5.75 1.5 5.75Z" fill="#191919"/>
      //           </svg>`;

      //       //   // Update the SVG icon in the size guide button
      //         const sizeGuideButton = sizeChartBtn.querySelector('.product-size-guide .product-size-guide__drawer-btn');
      //         if (sizeGuideButton) {
      //           sizeGuideButton.querySelector('svg').outerHTML = RulerSvg;
      //         }
      //       }

      //   // Process each target container
      //   targetContainers.forEach((targetContainer, index) => {
      //     const firstOptionBox = targetContainer.querySelector('.option-selectable-boxes');
      //     const legends = targetContainer.querySelectorAll('.option-selectable-boxes .input-fieldset__legend');

      //     if (firstOptionBox) {
      //       const clonedSizeChartBtn = index === 0 ? sizeChartBtn : sizeChartBtn.cloneNode(true);
      //       firstOptionBox.insertAdjacentElement('afterend', clonedSizeChartBtn);
      //     }

      //     // Check if "Charger" is mentioned and append message if needed
      //     let shouldAppendMsg = false;
      //     legends.forEach(legend => {
      //       if (legend.textContent.includes("Charger")) {
      //         shouldAppendMsg = true;
      //       }
      //     });

      //     if (shouldAppendMsg) {
      //       targetContainer.insertAdjacentHTML('beforeend', inBootMsg);
      //     }
      //   });
      // } else {
      //   console.log('sizeChartBtn or targetContainers not found');
      // }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const flyouts = document.querySelectorAll(
    '[data-component="flyout"][data-component-type="component"]'
  );
  const mediaZoomElements = document.querySelectorAll(
    ".product-gallery__media-zoom"
  );
  const header = document.querySelector(".main-header");
  const body = document.querySelector("body");

  function toggleGalleryOpen(state) {
    body.classList.toggle("gallery-open", state);
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      toggleGalleryOpen(false);
    }
  });

  mediaZoomElements.forEach((element) => {
    element.addEventListener("click", () => toggleGalleryOpen(true));
  });

  const zoomIcon = document.querySelector(".product-gallery__media-zoom-icon");
  const zoomOut = document.querySelector(".product-gallery-modal__toggle");

  if (zoomIcon) {
    zoomIcon.addEventListener("click", () => toggleGalleryOpen(true));
  }

  if (zoomOut) {
    zoomOut.addEventListener("click", () => toggleGalleryOpen(false));
  }
});

// halo and bit page click triggering to main add to cart to add product to cart drawer
document.addEventListener("DOMContentLoaded", function () {
  function triggerButtonAction() {
    const actionButton = document.querySelector(
      ".template-product-smart-helmet .button-action.button-action--primary.button-action--medium.button-action--shadow"
    );
    const notifyButton = document.querySelector(
      ".template-product-smart-helmet .satc-notify-btn .satc-notify-btn_text"
    );

    if (notifyButton) {
      // Create a loader element
      const loader = document.createElement("div");
      loader.className = "loader";

      // Replace the text with loader
      notifyButton.innerHTML = "";
      notifyButton.appendChild(loader);
      notifyButton.disabled = true;

      // Force reflow to ensure loader visibility
      notifyButton.offsetHeight; // Trigger reflow

      // Set a timeout to reset the notify button after a delay
      setTimeout(() => {
        notifyButton.innerHTML = "Add to cart";
        notifyButton.disabled = false;
      }, 2500);
    }

    if (actionButton) {
      // Ensure visual changes are applied before performing the click action
      requestAnimationFrame(() => {
        // Perform the click action
        actionButton.click();
        // Reset attributes and class after a short delay
        actionButton.setAttribute("aria-busy", "false");
        actionButton.removeAttribute("data-loading");
        actionButton.classList.remove("no-animation");
      });
    }
  }

  document
    .querySelector(".satc-notify-btn")
    .addEventListener("click", function (event) {
      triggerButtonAction();
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const elementsToDisableAutoScroll2 = document.querySelectorAll(
    ".product__grid-column--details .product-block--variant_picker .variant-picker .options-selector .option-selectable-boxes:nth-child(2)"
  );
  const elementsToDisableAutoScroll4 = document.querySelectorAll(
    ".product__grid-column--details .product-block--variant_picker .variant-picker .options-selector .option-selectable-boxes:nth-child(4)"
  );
  const elementsToEnableAutoScroll3 = document.querySelectorAll(
    ".product__grid-column--details .product-block--variant_picker .variant-picker .options-selector .option-selectable-boxes:nth-child(3)"
  );

  let lastScrollPosition = 0;

  function disableAutoScroll() {
    lastScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    requestAnimationFrame(() => {
      window.scrollTo(0, lastScrollPosition);
    });

    // console.log('Auto scroll disabled');
  }

  function enableScroll() {
    // console.log('Scroll enabled');
    document.body.style.overflow = ""; // Reset overflow style
  }

  elementsToDisableAutoScroll2.forEach((element) => {
    element.addEventListener("click", disableAutoScroll);
  });

  elementsToDisableAutoScroll4.forEach((element) => {
    element.addEventListener("click", disableAutoScroll);
  });

  elementsToEnableAutoScroll3.forEach((element) => {
    element.addEventListener("click", (event) => {
      if (event.target.classList.contains("input-radio__input")) {
        enableScroll();
      }
    });
  });
});

function addNotifcationDataOnQuantityInCart(notification, checkerClass) {
  if (notification) {
    if (
      !notification.querySelector(
        checkerClass || ".cart-drawer__notification-message"
      )
    ) {
      let Html = `
   <div class="cart-drawer__notification-message">
       <div class="cart-drawer__notification-message-icon">
           <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path
                   d="M25.7656 7.73438C26.0469 8.01562 26.0469 8.53125 25.7656 8.8125L13.0156 21.5625C12.7344 21.8438 12.2188 21.8438 11.9375 21.5625L5.1875 14.8125C4.90625 14.5312 4.90625 14.0156 5.1875 13.7344C5.46875 13.4531 5.98438 13.4531 6.26562 13.7344L12.5 19.9688L24.6875 7.73438C24.9688 7.45312 25.4844 7.45312 25.7656 7.73438Z"
                   fill="#193154"
               ></path>
           </svg>
       </div>
       <span class="cart-drawer__notification-message-text" data-cart-drawer-notification-message-text=""> <span data-cart-drawer-notification-message-atc-singular="">Product added to your cart.</span> </span>
   </div>
   `;
      notification.innerHTML = Html;
    }
  }
}




// Get the modal and button elements
const modal = document.getElementById("warranty-modal");
const btn = document.getElementById("warranty-btn");
const closeBtn = modal.querySelector(".close");

// Open the modal
btn.onclick = function() {
  modal.style.display = "flex";
  document.body.classList.add("no-scroll");
}

// Close the modal using the close button
closeBtn.onclick = function() {
  modal.style.display = "none"; 
  document.body.classList.remove("no-scroll"); 
}

// Close the modal when Escape key is pressed
document.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    modal.style.display = "none";
    document.body.classList.remove("no-scroll");
  }
});
